import { DotsSixVertical } from '@phosphor-icons/react';

export function DragHandle({ attributes, listeners, ariaLabel = 'Reordenar' }) {
  return (
    <button
      type="button"
      className="cursor-grab touch-none rounded p-0.5 text-muted-foreground/70 hover:text-muted-foreground active:cursor-grabbing"
      aria-label={ariaLabel}
      {...attributes}
      {...listeners}
    >
      <DotsSixVertical className="h-4 w-4 shrink-0" aria-hidden />
    </button>
  );
}
